import React, { useState, useEffect, useRef, useMemo } from "react";
import fetch from "cross-fetch";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import { Paper } from "@mui/material";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { RepeatOneSharp } from "@mui/icons-material";
import Header from "../../../Shared/Header/Default/Herader";
import XeroxHeader from "../../../Shared/Header/Xerox/XeroxHeader";
import DefaultFooter from "../../../Shared/Footer/Default/Footer";
import XeroxFooter from "../../../Shared/Footer/Xerox/XeroxFooter";
import { useCookies } from "react-cookie";
import LoadingSpinner from "../../Controls/LoadingSpinner/LoadingSpinner";
import "babel-polyfill";
import { Translations } from "../../../Shared/Translation/Translations";
import LoadingXeroxSpinner from "../../Controls/LoadingSpinner/XeroxLoadingSpinner";
import "./Code.css";
import img1 from "../../../assets/images/Xerox/check2.png";
import check from "../../../assets/images/Rpost/check.png";
import email from "../../../assets/images/Xerox/email.png";
import pwd from "../../../assets/images/Xerox/pwdcode.png";
import ReCAPTCHA from "react-google-recaptcha";
import PersonalInfo from "../../../Shared/Modals/PersonalInfo.js";
import Select, { NonceProvider } from "react-select";
import '../../../Shared/Css/countryFlagStyles.css';
import EDisclosure from "../../../Shared/Modals/EDisclosure.js";
import RequestAccess from "../../../Shared/Modals/RequestAccess.js";
import { use } from "react";
import { useDispatch } from "react-redux";
import { fetchLanguageTranslations, selectPasscodeOptions } from "../../../store/language-slice.js";
import { useSelector } from "react-redux";
import { AppContext } from "../../../AppContext.js";

const Container = styled.div({
  paddingTop: "120px",
  textAlign: "center",
  margin: "0 auto",
});

const SubmitButton = styled(Button)({
  width: "120px",
  margin: "0 auto",
});

const FormContainer = styled(Paper)({
  width: "400px",
  height: "280px",
  padding: "40px 40px 20px 40px",
  margin: "0 auto",
});

const MessageContainer = styled(Paper)({
  padding: "20px",
});

const EmailInput = styled(TextField)({
  width: "300px",
  margin: "0 auto",
});

let ipAddress = 0;
const Code = ({ translationsMap: langTranslations }) => {

  const [rpd, setRpd] = useState({
    id: "",
    email: "",
    recipientId: "",
    data: "",
    ip: "",
    userSessionId: "",
    firstName: "",
    lastName: "",
  });
  const [selectedPasscodeOption, setSelectedPasscodeOption] = useState(0);
  // const passcodeOptions = ["Email", "Mobile", "Both"];
  let passcodeOptions = useRef([]);
  const [openPersonalInfo, setIsOpenPersonalInfo] = useState(false);
  const SITE_KEY = process.env.REACT_APP_reCAPTCHA_SITE_KEY;
  const SECRET_KEY = process.env.REACT_APP_reCAPTCHA_SECRET_KEY;
  const captchaRef = useRef(null);
  const [GoogleCaptchaSiteKey, setGoogleCaptchaSiteKey] = useState(
    "6Leo5RcjAAAAAC8azoEhkoOJcDWsxRvIZXnkqHQF"
  );
  const [verifyEmail, setVerifyEmail] = useState("");
  const [getCodeEmail, setGetCodeEmail] = useState("");
  const [passcode, setPasscode] = useState("");
  const [message, setMessage] = useState("");
  const [messageCode, setMessageCode] = useState("");
  const [screen, setScreen] = useState(4); //1:Enter your email address and the passcode,2:Get Passcode,3:Check your email
  const { documentId } = useParams();
  const navigate = useNavigate();
  const [senderEmilAddress, setSenderEmilAddress] = useState("");
  const { typeId } = useParams();
  const { level } = useParams();
  const { fileName } = useParams();
  const [modelopen, setOpen] = useState(false);
  const [Reader_UserVerificationFailure, setReader_UserVerificationFailure] =
    useState("");
  const [modelMessage, setModelMessage] = useState(
    Reader_UserVerificationFailure
  );
  const [cookies, setCookie] = useCookies(["RPDUserSession"]);

  const [name, setName] = useState("");
  const [isDisplayVerifyCode, setisDisplayVerifyCode] = useState(false);
  const [openLoader, setOpenLoader] = useState(false);
  const [languageTranslations, setLanguageTranslations] = [];
  const [openReaderNotes, setOpenReaderNotes] = useState(false);
  const [openRequestSucess, setOpenRequestSucess] = useState(false);
  const [readerNotes, setReaderNotes] = useState("");
  const [Reader_DocumentID, setReader_DocumentID] = useState("");
  const [Reader_EmailAdress, setReader_EmailAdress] = useState("");
  const [Reader_VerificationCode, setReader_VerificationCode] = useState("");
  const [Reader_VerificationCode_Header, setReader_VerificationCode_Header] =
    useState("");
  const [Reader_Authorize, setReader_Authorize] = useState("");
  const [Reader_VerificationCode_Message, setReader_VerificationCode_Message] =
    useState("");
  const [Reader_ClickHere, setReader_ClickHere] = useState("");
  const [Reader_AuthorizeFailure, setReader_AuthorizeFailure] = useState("");
  const [Reader_GetVerificationCode, setReader_GetVerificationCode] =
    useState("");
  const [
    Reader_VerificationCode_Instruction,
    setReader_VerificationCode_Instruction,
  ] = useState("");
  const [
    Reader_VerificationCode_Remember,
    setReader_VerificationCode_Remember,
  ] = useState("");
  const [Reader_PleaseGoBack, setReader_PleaseGoBack] = useState("");
  const [Reader_Submit, setReader_Submit] = useState("");
  const [Reader_ActualSize, setReader_ActualSize] = useState("");
  const [Reader_FitPage, setReader_FitPage] = useState("");
  const [Reader_FullWidth, setReader_FullWidth] = useState("");
  const [Reader_DistributionList, setReader_DistributionList] = useState("");
  const [Reader_SideNote, setReader_SideNote] = useState("");
  const [Reader_ReplyToOwner, setReader_ReplyToOwner] = useState("");
  const [Reader_Print, setReader_Print] = useState("");
  const [Reader_Zoom, setReader_Zoom] = useState("");
  const [Reader_EnterYourEmailAddress, setReader_EnterYourEmailAddress] =
    useState("");
  const [Reader_Email, setReader_Email] = useState("");
  const [Reader_Passcode, setReader_Passcode] = useState("");
  const [Reader_OK, setReader_OK] = useState("");
  const [Reader_Getpasscode, setReader_Getpasscode] = useState("");
  const [Reader_GetPasscode, setReader_GetPasscode] = useState("");
  const [
    Reader_EnterYourEmailAddressCode,
    setReader_EnterYourEmailAddressCode,
  ] = useState("");
  const [
    Reader_EnterYourEmailAddressCodeTextOption,
    setReader_EnterYourEmailAddressCodeTextOption,
  ] = useState("");
  const [
    Reader_EnterYourEmailAddressXerox,
    setReader_EnterYourEmailAddressXerox,
  ] = useState("");
  const [Reader_Cancel, setReader_Cancel] = useState("");
  const [Reader_DocumentExpired, setReader_DocumentExpired] = useState("");
  const [Reader_FailedVerifyCodeEmail, setReader_FailedVerifyCodeEmail] =
    useState("");
  const [Reader_Continue, setReader_Continue] = useState("");
  const [Reader_GeneralTermsFooter, setReader_GeneralTermsFooter] =
    useState("");
  const [Reader_GeneralTerms, setReader_GeneralTerms] = useState("");
  const [Reader_Patent, setReader_Patent] = useState("");
  const [Reader_CheckYourEmail, setReader_CheckYourEmail] = useState("");
  const [reader_APasscodeEmailed, setReader_APasscodeEmailed] = useState("");
  const [Reader_AVerificationCodeEmailed, setReader_AVerificationCodeEmailed] =
    useState("");
  const [Reader_TryAgain, setReader_TryAgain] = useState("");
  const [Reader_DocumentRestrictedAccess, setReader_DocumentRestrictedAccess] =
    useState("");
  const [Reader_ReachedMaximumViews, setReader_ReachedMaximumViews] =
    useState("");
  const [
    Reader_DocumentIsNoLongerAvailable,
    setReader_DocumentIsNoLongerAvailable,
  ] = useState("");
  const [
    Reader_InactivityYourSessionWillEnd,
    setReader_InactivityYourSessionWillEnd,
  ] = useState("");
  const [Reader_Minutes, setReader_Minutes] = useState("");
  const [Reader_Seconds, setReader_Seconds] = useState("");
  const [Reader_SessionTimedOut, setReader_SessionTimedOut] = useState("");
  const [Reader_YouHaveBeenInactive, setReader_YouHaveBeenInactive] =
    useState("");
  const [Reader_ContinueReadingDocument, setReader_ContinueReadingDocument] =
    useState("");
  const [
    Reader_PrintingDocumentIsNotPermitted,
    setReader_PrintingDocumentIsNotPermitted,
  ] = useState("");
  const [Reader_ConfirmYourVote, setReader_ConfirmYourVote] = useState("");
  const [Reader_OnlyVoteOnce, setReader_OnlyVoteOnce] = useState("");
  const [Reader_Like, setReader_Like] = useState("");
  const [Reader_Dislike, setReader_Dislike] = useState("");
  const [Reader_Voting, setReader_Voting] = useState("");
  const [Reader_ProtectedDocument, setReader_ProtectedDocument] = useState("");
  const [Reader_ProtectedDocumentAccess, setReader_ProtectedDocumentAccess] =
    useState("");
  const [Reader_AllRightsReserved, setReader_AllRightsReserved] = useState("");
  const [Reader_Terms, setReader_Terms] = useState("");
  const [
    Reader_DocumentServerUnavailable,
    setReader_DocumentServerUnavailable,
  ] = useState("");
  const [
    Reader_InternetConnectionRequired,
    setReader_InternetConnectionRequired,
  ] = useState("");
  const [
    Reader_EnteredEmailIsNotReadersList,
    setReader_EnteredEmailIsNotReadersList,
  ] = useState("");
  const [Reader_FailedSendVerifyCode, setReader_FailedSendVerifyCode] =
    useState("");

  const [Reader_DocName, setReader_DocName] = useState("");
  const [Reader_ID, setReader_ID] = useState("");
  const [Reader_EnterEmailGetPasscode, setReader_EnterEmailGetPasscode] =
    useState("");
  const [Reader_PleaseEnterSubject, setReader_PleaseEnterSubject] =
    useState("");
  const [Reader_EmailSuccessfullySent, setReader_EmailSuccessfullySent] =
    useState("");
  const [Reader_DigitalRightsManagement, setReader_DigitalRightsManagement] =
    useState("");
  const [Reader_ProtectedDocumentViewer, setReader_ProtectedDocumentViewer] =
    useState("");
  const [Reader_ViewDistributionList, setReader_ViewDistributionList] =
    useState("");
  const [Reader_UsersList, setReader_UsersList] = useState("");
  const [Reader_ViewSideNote, setReader_ViewSideNote] = useState("");
  const [Reader_NoteFrom, setReader_NoteFrom] = useState("");
  const [Reader_ReplyToDocument, setReader_ReplyToDocument] = useState("");
  const [Reader_ClickToPrint, setReader_ClickToPrint] = useState("");
  const [Reader_Send, setReader_Send] = useState("");
  const [Reader_Message, setReader_Message] = useState("");
  const [Reader_Subject, setReader_Subject] = useState("");
  const [Reader_ToAddress, setReader_ToAddress] = useState("");
  const [Reader_YouWillLoggedIn, setReader_YouWillLoggedIn] = useState("");
  const [Reader_ClickToVote, setReader_ClickToVote] = useState("");
  const [Reader_DocumentHasNoAccess, setReader_DocumentHasNoAccess] =
    useState("");
  const [Reader_AccessDocument, setReader_AccessDocument] = useState("");
  const [
    Reader_SessionExpiredAccessDocument,
    setReader_SessionExpiredAccessDocument,
  ] = useState("");
  const [Reader_PleaseTryAgain, setReader_PleaseTryAgain] = useState("");
  const [Reader_CheckYourConnection, setReader_CheckYourConnection] =
    useState("");
  const [Reader_LegalNotices, setReader_LegalNotices] = useState("");
  const [Reader_ClickServiceLevelTerms, setReader_ClickServiceLevelTerms] =
    useState("");
  const [Reader_OtherService, setReader_OtherService] = useState("");
  const [Reader_YourDocumentadressAcess, setReader_YourDocumentadressAcess] =
    useState("");
  const [Reader_ReadMore, setReader_ReadMore] = useState("");
  const [Reader_InternetConnectProblem, setReader_InternetConnectProblem] =
    useState("");
  const [
    Reader_ConnectivityReauthenticate,
    setReader_ConnectivityReauthenticate,
  ] = useState("");
  const [PasscodeType, setPasscodeType] = useState("password");
  const [onlineStatus, setOnlineStatus] = useState(true);
  const [Reader_BotInfoMessage, setReader_BotInfoMessage] = useState("");
  const [Reader_BlockMessage, setReader_BlockMessage] = useState("");
  const [Reader_robot, setReader_robot] = useState("");
  const [Reader_BotVerifiedMessage, setReader_BotVerifiedMessage] =
    useState("");
  const [Reader_Botverified, setReader_Botverified] = useState("");
  const [noInternetImg, setnoInternetImg] = useState(
    "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"
  );
  const [blockImg, setblockImg] = useState(
    "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"
  );
  const [allowedCountryCodeFlag, setAllowedCountryCodeFlag] = useState(false);
  const [isButtonDisabled, setButtonDisabled] = useState(true);
  const [Reader_ClickGetPasscode, setReader_ClickGetPasscode] = useState("");
  const [Reader_AuthenticatingPleaseWait, setReader_AuthenticatingPleaseWait] =
    useState("");

  const [
    Reader_RequestingPassCodePleaseWait,
    setReader_RequestingPassCodePleaseWait,
  ] = useState("");
  const [
    Reader_ReplyToDocumentPleaseWait,
    setReader_ReplyToDocumentPleaseWait,
  ] = useState("");
  const [Reader_PrintDocumentPleaseWait, setReader_PrintDocumentPleaseWait] =
    useState("");
  const [
    Reader_NavigatingBnPagesPleaseWait,
    setReader_NavigatingBnPagesPleaseWait,
  ] = useState("");
  const [Reader_RequestAccess, setReader_RequestAccess] = useState("");
  const [Email_RequestHasBeenSent, setEmail_RequestHasBeenSent] = useState("");
  const [Email_PleaseWaitForApproval, setEmail_PleaseWaitForApproval] =
    useState("");
  const [Email_NoteOptional, setEmail_NoteOptional] = useState("");
  const [docSenderAddress, setDocSenderAddress] = useState("");

  const [Loadingmessage, setLoadingmessage] = useState(0);
  const [reader_RPostAPasscodeEmailed, setReader_RPostAPasscodeEmailed] = useState("");
  const [reader_RPostCheckYourEmail, setRPostReader_CheckYourEmail] = useState("");
  const [reader_RPostGetPasscode, setRPosteader_GetPasscode] = useState("");
  const [reader_RPostEmail, setReader_RPostEmail] = useState("");
  const [rPostEmail_Passcode, setRPostEmail_Passcode] = useState("");
  const [reader_Note, setReader_Note] = useState("");
  const [reader_Optional, setReader_Optional] = useState("");
  const [reader_RPostEnterYourEmailAddressCode, setReader_RPostEnterYourEmailAddressCode] = useState("");
  const [reader_validEmailMobile, setReader__validEmailMobile] = useState("");
  const [reader_ValidateMobileNumber, setReader_ValidateMobileNumber] = useState("");
  const bothEmailAndMobileHeader = useRef("");
  const whatsAppHeader = useRef("");
  const smsAndWhatsAppHeader = useRef("");
  const checkYourEmailMobile = useRef("");
  const passCodeSent = useRef("");
  const passCodeSentViaText = useRef("");
  const [countryCodes, setCountryCodes] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [mobileNum, setMobileNum] = useState("");
  const isLevel1 = useRef(false);
  const [communicationChannel, setCommunicationChannel] = useState({
    email: false,
    text: false,
    whatsApp: false,
  });
  const selectCountryCode = useRef("");
  const selectCommunication = useRef("");
  const defaultOption = { value: "", label: "Country Code" };
  const [mobileCountryCode, setMobileCountryCode] = useState(null);
  const [Reader_LoadingPleaseWait, setReader_LoadingPleaseWait] = useState("");
  const [Reader_SendingYourPasscode, setReader_SendingYourPasscode] = useState("");
  const [Reader_SendingYourRequest, setReader_SendingYourRequest] = useState("");
  useEffect(() => { }, [screen]);
  useEffect(() => { }, [getCodeEmail]);

  // Cleanup countdown timer on unmount
  useEffect(() => {
    return () => {
      if (countdownTimerRef.current) {
        clearInterval(countdownTimerRef.current);
        countdownTimerRef.current = null;
      }
    };
  }, []);
  useEffect(() => {
    window.addEventListener("online", () => setOnlineStatus(true));
    window.addEventListener("offline", () => setOnlineStatus(false));
  }, []);
  //const [ip, setIpaddress] = useState("");
  const [isBlock, setisBlock] = useState(false);

  const personalInfoRef = useRef(null);
  const disclaimerRef = useRef();
  const countdownTimerRef = useRef(null);
  const Reader_Agree = useRef("");
  const Reader_Disagree = useRef("");
  const Reader_TermsofService = useRef("");;

  const EdisclosureSetting = useRef({ Edisclosure: false, termsOfService: "" });

  const emailOptionDisabledAndMobileOptionEnabled = useRef("");
  const emailOptionEnabledAndMobileOptionDisabled = useRef("");
  const checkYourMobile = useRef("");
  const reader_RequestAccess = useRef("");
  const firstNameRef = useRef("");
  const lastNameRef = useRef("");
  const optionalText = useRef("");
  const requestAccessTextForEmailMobile = useRef("");
  const requestAccessTextForEmail = useRef("");
  const firstNameOfRequestAccess = useRef("");
  const lastNameOfRequestAccess = useRef("");
  const readerMobileNumberPasscodeText = useRef("");

  const showOptionalPlaceholder = useRef(false);
  const authTypeSelectedForRecipient = useRef("");
  const requestAccessRef = useRef();
  const requestDetailsRef = useRef({
    firstName: "",
    lastName: "",
    email: "",
    mobileNumber: "",
    mobileCountryCode: "",
    note: "",
  });

  const dispatch = useDispatch();

  let translationsMap = useSelector(
    (state) => state?.languageTranslation?.translationsMap
  );
  if (Object.keys(translationsMap).length === 0) {
    translationsMap = langTranslations ? { ...langTranslations } : {};
  }

  passcodeOptions.current = useMemo(() => {
    if (Object.keys(translationsMap).length === 0) return [];
    const passcodeOptions = [
      translationsMap["Reader_Email"],
      translationsMap["Reader_Email_PasscodeOption2"],
      translationsMap["Reader_Email_PasscodeOption3"],
    ].filter(Boolean);

    return passcodeOptions;
  }, [translationsMap]);



  useEffect(() => {
    if (AppContext.IsEnableMergeCalls == true)
      ValidateReaderAndGetSettings(0);
    else {
      getipAddress(0);
      getDocumentLevelSettings();
    }
  }, []);
  useEffect(() => {
    window.addEventListener("popstate", (e) => {
      window.history.go(1);
    });
  }, []);
  async function ValidateReaderAndGetSettings(flag) {
  console.warn("when getipAddress called " + new Date());

  let browserName = getBrowserName();
  let usercookieId = localStorage.getItem("local_" + documentId) || "";

  const url = `${process.env.REACT_APP_API}/ValidateReaderAndGetSettings?documentId=${documentId}` +
              `&email=&code=&ip=${ipAddress || ""}` +
              `&UserSessionId=${usercookieId}` +
              `&userBrowser=${browserName}`;

  try {
    const res = await fetch(url);
    const full = await res.json();
    console.log("FULL API RESPONSE:", full);

    const ipData = full.ipAddressDetails || null;
    const docSettings = full.documentLevelSettings || null;
    const isBlocked = full.isBlocked || false;
    if (!ipData) {
      console.error("No ipAddressDetails received");
      setOpenLoader(false);
      return;
    }
   
    try {
      if (docSettings) {
        console.log("Document Settings:", docSettings);
        if (docSettings.countryCodes) {
          const formattedOptions = [
            {
              value: "+Code",
              label: "+Code",
              languageCode: "+Code",
              mobileMaxLeng: 0,
            },
            ...docSettings.countryCodes.map((item) => ({
              value: `${item.dialCode}-${item.countryCode}`,
              label: `${item.countryName} (${item.dialCode})`,
              languageCode: item.countryCode.toLowerCase(),
              mobileMaxLeng: item.mobileMaxLeng,
            })),
          ];
          setCountryCodes(formattedOptions);
        }
        setCommunicationChannel((prev) => ({
          ...prev,
          email: docSettings.isEmail,
          text: docSettings.isSMS,
          whatsApp: docSettings.isWhatApp,
        }));
        EdisclosureSetting.current.Edisclosure = docSettings.isEDisclosure;
        EdisclosureSetting.current.termsOfService = docSettings.termsOfService;
      }
    } catch (error) {
      console.log("Document settings error:", error);
    }
    const countryCode = ipData.country_code?.toLowerCase() || "";
    const regionCode = ipData.region_code?.toLowerCase() || "";
    const allowedList = [
      "ch","al","ad","at","by","be","ba","bg","hr","cy","cz","dk","ee","fi","fr",
      "de","gr","hu","is","ie","it","xk","lv","li","lt","lu","mt","md","mc","me",
      "nl","mk","no","pl","pt","ro","ru","sm","rs","sk","si","se","ua","gb","va",
      "gb-eng","gb-sct","gb-wls","gb-nir"
    ];

    if (allowedList.includes(countryCode) || (countryCode === "us" && regionCode === "ca")) {
      setAllowedCountryCodeFlag(true);
    }

    if (flag === 0) {
      ipAddress = ipData.ip;
       localStorage.setItem("TypeId", "");
        localStorage.setItem("TypeId", typeId);
         if (isBlocked) {
           console.warn("User is blocked. Navigating to Block Screen.");
           setisBlock(isBlocked);
           setScreen(4);
           setOpenLoader(false);
           return;
         } else {
           setisBlock(isBlocked);
           setScreen(1);
           setOpenLoader(false);
         }
      if (level === "1") {
        setOpenLoader(false);
        checkUserSession("");
      } 
      else if (document.cookie.indexOf(`${documentId}=`) !== -1) {
        let cookieId = getCookie(documentId);

        if (cookieId) {
          setOpenLoader(false);
          checkUserSession(cookieId);
        } else {
          setOpenLoader(false);
          setisDisplayVerifyCode(true);
        }
      } 
      else if (usercookieId) {
        setOpenLoader(false);
        checkUserSession(usercookieId);
      } 
      else {
        setOpenLoader(false);
        setisDisplayVerifyCode(true);
      }
    }
  } catch (error) {
    console.log("IP API ERROR:", error);
    setOpenLoader(false);
  }
}
  const getDocumentLevelSettings = async () => {
    try {
      const url = `${process.env.REACT_APP_API}/docs/GetDocumentLevelSettingDetails/${documentId}`;
      const response = await fetch(url);
      const data = await response.json();
      console.log(data);
      if (data) {
        if (data.countryCodes != null) {
          const formattedOptions = [
            {
              value: "+Code", // Use an empty string or any value to represent "default"
              label: "+Code",// Placeholder text for the default option
              languageCode: "+Code", // Optional: Add a default language code if needed
              mobileMaxLeng: 0, // Optional: Default value for max length
            },
            ...data.countryCodes.map((item) => ({
              value: `${item.dialCode}-${item.countryCode}`,
              label: `${item.countryName} (${item.dialCode})`,
              languageCode: item.countryCode.toLowerCase(),
              mobileMaxLeng: item.mobileMaxLeng,
            })),
          ];
          setCountryCodes(formattedOptions);
        }
        setCommunicationChannel((prev) => {
          return {
            ...prev,
            email: data.isEmail,
            text: data.isSMS,
            whatsApp: data.isWhatApp,
          };
        });
        EdisclosureSetting.current.Edisclosure = data.isEDisclosure;
        EdisclosureSetting.current.termsOfService = data.termsOfService;

      }
    } catch (error) {
      console.log(error);
    }
  };
  async function getipAddress(flag) {
    console.warn("when getipAddress called " + new Date());
    const url = `${process.env.REACT_APP_API}/getipaddressipapi`;
    let json;
    try {
      var res = await fetch(url);
      json = await res.json();
      json = json.ipAddressDetails;
      console.warn("when getipAddress response " + new Date());
      var countryCode =
        json.country_code != null
          ? json.country_code.toString().toLowerCase()
          : "";
      var regionCode =
        json.region_code != null
          ? json.region_code.toString().toLowerCase()
          : "";
      if (
        countryCode === "ch" ||
        countryCode === "al" ||
        countryCode === "ad" ||
        countryCode === "at" ||
        countryCode === "by" ||
        countryCode === "be" ||
        countryCode === "ba" ||
        countryCode === "bg" ||
        countryCode === "hr" ||
        countryCode === "cy" ||
        countryCode === "cz" ||
        countryCode === "dk" ||
        countryCode === "ee" ||
        countryCode === "fi" ||
        countryCode === "fr" ||
        countryCode === "de" ||
        countryCode === "gr" ||
        countryCode === "hu" ||
        countryCode === "is" ||
        countryCode === "ie" ||
        countryCode === "it" ||
        countryCode === "xk" ||
        countryCode === "lv" ||
        countryCode === "li" ||
        countryCode === "lt" ||
        countryCode === "lu" ||
        countryCode === "mt" ||
        countryCode === "md" ||
        countryCode === "mc" ||
        countryCode === "me" ||
        countryCode === "nl" ||
        countryCode === "mk" ||
        countryCode === "no" ||
        countryCode === "pl" ||
        countryCode === "pt" ||
        countryCode === "ro" ||
        countryCode === "ru" ||
        countryCode === "sm" ||
        countryCode === "rs" ||
        countryCode === "sk" ||
        countryCode === "si" ||
        countryCode === "se" ||
        countryCode === "se" ||
        countryCode === "ch" ||
        countryCode === "ua" ||
        countryCode === "gb" ||
        countryCode === "va" ||
        countryCode === "gb-eng" ||
        countryCode === "gb-sct" ||
        countryCode === "gb-wls" ||
        countryCode === "gb-nir" ||
        (countryCode === "us" && regionCode === "ca")
      )
        setAllowedCountryCodeFlag(true);
      if (flag == 0) {
        ipAddress = json.ip;
        let localuserSessionId = localStorage.getItem("local_" + documentId);
        CheckisBlocked(localuserSessionId);
        if (level == "1") {
          let usercookieId = "";
          setOpenLoader(false);
          checkUserSession(usercookieId);
        } else if (document.cookie.indexOf(`${documentId}=`) != -1) {
          let usercookieId = getCookie(documentId);
          if (usercookieId != null && usercookieId != "") {
            setOpenLoader(false);
            checkUserSession(usercookieId);
          } else {
            setOpenLoader(false);
            setisDisplayVerifyCode(true);
          }
        } else if (localuserSessionId != "" && localuserSessionId != null) {
          setOpenLoader(false);
          checkUserSession(localuserSessionId);
        } else {
          setOpenLoader(false);
          setisDisplayVerifyCode(true);
        }
      }
    } catch (error) {
      console.log(error);
      setOpenLoader(false);
      return () => { };
    }
  }

  const CheckisBlocked = async (usercookieId) => {
    console.warn("when ValidateReaderAuthorization called " + new Date());
    setOpenLoader(true);
    let browserName = getBrowserName();
    const url = `${process.env.REACT_APP_API}/docs/ValidateReaderAuthorization/${documentId}`;
    let result;
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: "",
        code: "",
        ip: ipAddress,
        UserSessionId: usercookieId,
        userBrowser: browserName,
      }),
    };

    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        console.warn(
          "when ValidateReaderAuthorization responded " + new Date()
        );
        if (response !== null) {
          if (response) {
            setisBlock(response);
            setScreen(4);
          } else {
            setisBlock(response);
            setScreen(1);
          }
        }
      })
      .catch((error) => {
        setOpenLoader(false);
        console.log(error);
      });
  };

  const checkUserSession = async (usercookieId) => {
    console.warn("when verify/ called " + new Date());
    setOpenLoader(true);
    let browserName = getBrowserName();
    const url = `${process.env.REACT_APP_API}/docs/verify/${documentId}`;
    let result;
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: "",
        code: "",
        ip: ipAddress,
        UserSessionId: usercookieId,
        userBrowser: browserName,
      }),
    };

    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        console.warn("when verify/ responded " + new Date());
        let showDisclosure = false;
        let isAgreed = JSON.parse(localStorage.getItem(`EDisclosure_${documentId}_${response.recipientEmail}_Agreed`))
        if (
          response &&
          response.recipientId !== "" &&
          response.recipientId !== null
        ) {
          localStorage.setItem("local_" + documentId, response.userSessionId);
          setCookie(documentId, response.userSessionId);
          sessionStorage.setItem(
            "session_" + documentId,
            response.userSessionId
          );
          const isShowPersonalInfo =
            !response.firstName && !response.lastName && !response.mobileNumber;
          if (response.userSessionId === "") {
            showDisclosure = true;
          } else if (response.userSessionId !== "" && !isAgreed) {
            showDisclosure = true;
          }

          if (showDisclosure && EdisclosureSetting.current.Edisclosure && typeId !== "1") {
            setOpenLoader(false);
            disclaimerRef.current.open(
              isShowPersonalInfo,
              {
                id: documentId,
                email: response.recipientEmail,
                recipientId: response.recipientId,
                data: "",
                ip: ipAddress,
                userSessionId: response.userSessionId,
              },
              documentId,
              isLevel1.current,
              countryCodes,
              communicationChannel,
              translationsMap.Reader_OK,
              translationsMap.Reader_LoadingPleaseWait,
              translationsMap.Reader_Agree,
              translationsMap.Reader_Disagree,
              translationsMap.Reader_TermsofService,
              EdisclosureSetting.current.termsOfService,
              {
                documentId: "",
                recipientId: "",
                userSessionId: "",
                redirectUrl: "",
              },
            );
          }
          else {
            console.log(translationsMap);
            read(verifyEmail, response.recipientId, usercookieId);
          }
        } else if (response.level1Authenticated) {
          isLevel1.current = response.level1Authenticated;
          if (response.userSessionId !== "" && !isAgreed && EdisclosureSetting.current.Edisclosure) {
            showDisclosure = true;
            const isShowPersonalInfo = false;
            if (showDisclosure && EdisclosureSetting.current.Edisclosure && typeId !== "1") {
              setOpenLoader(false);
              disclaimerRef.current.open(
                isShowPersonalInfo,
                {
                  id: documentId,
                  email: response.recipientEmail,
                  recipientId: response.recipientId,
                  data: "",
                  ip: ipAddress,
                  userSessionId: response.userSessionId,
                },
                documentId,
                isLevel1.current,
                countryCodes,
                communicationChannel,
                translationsMap.Reader_OK,
                translationsMap.Reader_LoadingPleaseWait,
                translationsMap.Reader_Agree,
                translationsMap.Reader_Disagree,
                translationsMap.Reader_TermsofService,
                EdisclosureSetting.current.termsOfService,
                {
                  documentId: documentId,
                  recipientId: response.recipientId,
                  userSessionId: response.userSessionId,
                  redirectUrl: response.redirectUrl,
                },

              );
            }
          } else {
            localStorage.setItem("local_" + documentId, response.userSessionId);
            setCookie(documentId, response.userSessionId);
            sessionStorage.setItem(
              "session_" + documentId,
              response.userSessionId
            );
            console.log(documentId);
            if (isValidURL(response.redirectUrl)) {
              const redirectPath = new URL(response.redirectUrl).pathname;
              navigate(redirectPath, {
                replace: true,
                state: {
                  translationsMap: { ...translationsMap }
                }
              });
            } else {
              navigate(response.redirectUrl, {
                replace: true,
                state: {
                  translationsMap: { ...translationsMap }
                }
              });
            }
          }

        } else if (response.authenticated) {
          setOpenLoader(false);
          localStorage.setItem(
            "ContinentCode_" + documentId,
            response.continentCode
          );
          localStorage.setItem(
            "RecipientEmail_" + documentId,
            response.recipientEmail
          );
          localStorage.setItem("RecipientIp_" + documentId, response.readerIp);
          localStorage.setItem("Network_" + documentId, response.network);
          localStorage.setItem("Location_" + documentId, response.location);
          localStorage.setItem("UserAgent_" + documentId, response.userAgent);
          if (response.message != null && response.message === "declined") {
            localStorage.setItem("DeclinedVar_" + documentId, "true");
          } else {
            localStorage.setItem("DeclinedVar_" + documentId, "false");
          }
          if (isValidURL(response.redirectUrl)) {
            const redirectPath = new URL(response.redirectUrl).pathname;
            navigate(redirectPath, {
              replace: true,
              state: {
                translationsMap: { ...translationsMap }
              }
            });
          } else {
            navigate(response.redirectUrl, {
              replace: true,
              state: {
                translationsMap: { ...translationsMap }
              }
            });
          }
        } else {
          setOpenLoader(false);
          console.log(response.sessionAuthenticated);
          setisDisplayVerifyCode(true);
        }
      })
      .catch((error) => {
        setOpenLoader(false);
        setisDisplayVerifyCode(true);
        console.log(error);
        setMessage(Reader_FailedSendVerifyCode + " ");
      });
  };
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  const globePlaceholder = {
    label: "+Code",
    value: "+Code",
    languageCode: "+Code", // Used to show the globe icon
    isPlaceholder: true
  };
  function getBrowserName() {
    var ua = navigator.userAgent,
      tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edg)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(" ");
  }
  function handleGetCodeEmail(event) {
    setGetCodeEmail(event.target.value.trim());
  }
  function handleMobileNum(event) {
    if (/^\d*$/.test(event.target.value.trim())) {
      setMobileNum(event.target.value.trim());
    }
  }

  const handleMobileCountryCode = (e) => {
    e.value = e.value.split('-')[0];
    if (e.languageCode == 'ca') {
      const updatedOptions1 = countryCodes.map((option) => {
        if (option.languageCode != 'ca' || option.languageCode == '') {
          return { ...option, value: `${option.value.split('-')[0]}-${option.languageCode.toUpperCase()}` }; // Update value for US
        }
        return option;
      });
      setCountryCodes(updatedOptions1);
    }
    if (e.languageCode == 'us') {
      const updatedOptions2 = countryCodes.map((option) => {
        if (option.languageCode != 'us' || option.languageCode == '') {
          return { ...option, value: `${option.value.split('-')[0]}-${option.languageCode.toUpperCase()}` }; // Update value for US
        }
        return option;
      });
      setCountryCodes(updatedOptions2);
    }
    setMobileCountryCode(e);
  };

  function handleVerifyEmail(event) {
    setVerifyEmail(event.target.value);
  }
  function handlePasscode(event) {
    setPasscode(event.target.value.replace(/\s/g, ""));
  }

  const handleClick = async (event) => {
    event.preventDefault();
    getCode();

  };
  const handleKeyUp = async (event) => {
    if (selectedPasscodeOption === 2) {
      if (getCodeEmail !== "" && mobileNum !== "") setButtonDisabled(false);
      else setButtonDisabled(true);
      return;
    }
    if (event.target.value.trim() === "") setButtonDisabled(true);
    else setButtonDisabled(false);
  };
  const getCode = async (Email) => {
    const browserlanguage = window.navigator.language;
    const url = `${process.env.REACT_APP_API
      }/docs/code/${documentId}/?email=${encodeURIComponent(
        getCodeEmail
      )}&browserlanguage=${browserlanguage}&securitylevel=${encodeURIComponent(
        level
      )}&mobileCountryCode=${encodeURIComponent((mobileCountryCode?.value === undefined || mobileCountryCode?.value === "+Code") ? "" : mobileCountryCode.value)}&mobileNumber=${encodeURIComponent(mobileNum)}`;
    let result;
    setLoadingmessage(2);
    setOpenLoader(true);
    fetch(url, { mode: "cors" })
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        console.log(response.status);

        if (response && response.authenticated) {
          console.log(response.status);
          setScreen(3);
          authTypeSelectedForRecipient.current = response.authTypeAssignedForReciepient;
          if (response.authTypeAssignedForReciepient === "text" && (selectedPasscodeOption === 2)) {
            setMessage(`${translationsMap.emailOptionDisabledAndMobileOptionEnabled}  ${mobileCountryCode?.value ?? ""} ${mobileNum}`);
          } else if (response.authTypeAssignedForReciepient === "email" && (selectedPasscodeOption === 2)) {
            setMessage(`${translationsMap.emailOptionEnabledAndMobileOptionDisabled} ${getCodeEmail}`);
          } else {
            setMessage(
              ((communicationChannel.text || communicationChannel.whatsApp) && (mobileNum != "") && (getCodeEmail == ""))
                ? translationsMap.passCodeSent.replace("{0} and {1}", "")
                : ((communicationChannel.text || communicationChannel.whatsApp) && (mobileNum != "") && (getCodeEmail != ""))
                  ? translationsMap.passCodeSent
                  : translationsMap.Reader_RPostAPasscodeEmailed + " "
            );
            if (((communicationChannel.text || communicationChannel.whatsApp) && !communicationChannel.email) && (mobileNum != "")) {
              setSelectedPasscodeOption(1);
            }

          }
          setOpenLoader(false);
          setMessageCode("");
        } else if (
          response &&
          !response.authenticated &&
          response.errorMessage != null
        ) {
          console.log(response.status);
          if (response.mobileNumberOptional)
            showOptionalPlaceholder.current = true;
          else
            showOptionalPlaceholder.current = false;

          // Handle RPD002 - passcode recently generated, show countdown
          if (response.msgCode === "RPD002" && response.remainingSeconds > 0) {
            let seconds = response.remainingSeconds;
            const templateMsg = response.errorMessage;

            // Replace @@ with initial seconds
            const initialMsg = templateMsg.replace("@@", seconds);
            setOpen(true);
            setModelMessage(initialMsg);
            setMessage(initialMsg);
            setMessageCode(response.msgCode || response.messageCode);
            setOpenLoader(false);

            // Clear any existing timer
            if (countdownTimerRef.current) {
              clearInterval(countdownTimerRef.current);
            }

            // Start countdown
            countdownTimerRef.current = setInterval(() => {
              seconds -= 1;
              if (seconds <= 0) {
                // Auto-close the popup
                clearInterval(countdownTimerRef.current);
                countdownTimerRef.current = null;
                setOpen(false);
                setModelMessage("");
                setMessage("");
                setMessageCode("");
              } else {
                const updatedMsg = templateMsg.replace("@@", seconds);
                setModelMessage(updatedMsg);
                setMessage(updatedMsg);
              }
            }, 1000);
          } else {
            setOpen(true);
            setModelMessage(response.errorMessage);
            setMessage(response.errorMessage);
            setMessageCode(response.messageCode);
            setOpenLoader(false);
          }
        } else if (
          response &&
          !response.authenticated &&
          !response.redirectUrl != null
        ) {
          localStorage.setItem("FileName", response.fileName);
          localStorage.setItem("url", response.redirectUrl);
          localStorage.setItem("documentId", documentId);
          if (isValidURL(response.redirectUrl)) {
            const redirectPath = new URL(response.redirectUrl).pathname;
            navigate(redirectPath, {
              replace: true,
              state: {
                translationsMap: { ...translationsMap }
              }
            });
          } else {
            navigate(response.redirectUrl, {
              replace: true,
              state: {
                translationsMap: { ...translationsMap }
              }
            });
          }
        } else if (response && !response.authenticated) {
          console.log(response.status);
          setOpen(true);
          setModelMessage(response.errorMessage);
          setMessage(response.errorMessage);
          setOpenLoader(false);
        } else {
          console.log(response.status);
          setOpen(true);
          setModelMessage(translationsMap.Reader_EnteredEmailIsNotReadersList);
          setMessage(translationsMap.Reader_FailedSendVerifyCode);
          setOpenLoader(false);
        }
      })
      .catch((error) => {
        setOpenLoader(false);
        console.log(error);
        setMessage(translationsMap.Reader_FailedSendVerifyCode);
      });
  };

  function isValidURL(urlString) {
    try {
      new URL(urlString);
      return true;
    } catch (error) {
      return false;
    }
  }
  const verifyCode = async () => {
    console.warn("when verify/ called " + new Date());
    let browserName = getBrowserName();
    console.log(`${process.env.REACT_APP_API}`);
    setMessageCode("");
    if (verifyEmail == '' || passcode == '') {
      setOpen(true);
      setModelMessage(translationsMap.Reader_UserVerificationFailure);
      return;
    }
    const url = `${process.env.REACT_APP_API}/docs/verify/${documentId}`;
    setLoadingmessage(1);
    setOpenLoader(true);
    let result;
    const requestOptions = {
      mode: "cors",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: verifyEmail,
        code: passcode,
        ip: ipAddress,
        userBrowser: browserName,
      }),
    };
    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        console.warn("when verify/ responded " + new Date());
        console.log(response);
        console.log(response.status);

        if (response && !response.authenticated) {
          if (response.isBlocked) {
            setisBlock(true);
            setScreen(4);
          } else {
            setOpen(true);
            setModelMessage(translationsMap.Reader_UserVerificationFailure);
          }
          setOpenLoader(false);
        } else if (
          response &&
          response.recipientId !== "" &&
          response.recipientId !== null
        ) {
          console.log(response.status);
          console.log(response.recipientId);
          localStorage.setItem("local_" + documentId, response.userSessionId);
          setCookie(documentId, response.userSessionId);
          sessionStorage.setItem(
            "session_" + documentId,
            response.userSessionId
          );
          const isShowPersonalInfo =
            !response.firstName && !response.lastName && !response.mobileNumber;
          if (EdisclosureSetting.current.Edisclosure && typeId !== "1") {
            setOpenLoader(false);
            disclaimerRef.current.open(
              isShowPersonalInfo,
              {
                id: documentId,
                email: verifyEmail,
                recipientId: response.recipientId,
                data: "",
                ip: ipAddress,
                userSessionId: response.userSessionId,
              },
              documentId,
              isLevel1.current,
              countryCodes,
              communicationChannel,
              translationsMap.Reader_OK,
              translationsMap.Reader_LoadingPleaseWait,
              translationsMap.Reader_Agree,
              translationsMap.Reader_Disagree,
              translationsMap.Reader_TermsofService,
              EdisclosureSetting.current.termsOfService,
              {
                documentId: "",
                recipientId: "",
                userSessionId: "",
                redirectUrl: "",
              },
            );
          } else if (
            (response.firstName === "" || response.firstName === null) &&
            (response.lastName === "" || response.lastName === null) &&
            (response.mobileNumber === "" || response.mobileNumber === null) &&
            typeId !== "1"
          ) {
            setOpenLoader(false);
            personalInfoRef.current.onShow(
              true,
              {
                id: documentId,
                email: verifyEmail,
                recipientId: response.recipientId,
                data: "",
                ip: ipAddress,
                userSessionId: response.userSessionId,
              },
              documentId,
              countryCodes,
              communicationChannel,
              translationsMap.Reader_OK
            );
            console.log(screen);
          } else {

            read(verifyEmail, response.recipientId, response.userSessionId);
          }
        } else if (
          response &&
          response.redirectUrl != null &&
          response.redirectUrl != ""
        ) {
          localStorage.setItem("FileName", response.fileName);
          localStorage.setItem("url", response.redirectUrl);
          localStorage.setItem("documentId", documentId);
          localStorage.setItem(
            "ContinentCode_" + documentId,
            response.continentCode
          );
          localStorage.setItem(
            "RecipientEmail_" + documentId,
            response.recipientEmail
          );
          localStorage.setItem("RecipientIp_" + documentId, response.readerIp);
          localStorage.setItem("Network_" + documentId, response.network);
          localStorage.setItem("Location_" + documentId, response.location);
          localStorage.setItem("UserAgent_" + documentId, response.userAgent);
          if (response.message != null && response.message === "declined") {
            localStorage.setItem("DeclinedVar_" + documentId, "true");
          } else {
            localStorage.setItem("DeclinedVar_" + documentId, "false");
          }
          if (isValidURL(response.redirectUrl)) {
            const redirectPath = new URL(response.redirectUrl).pathname;
            navigate(redirectPath, {
              replace: true,
              state: {
                translationsMap: { ...translationsMap }
              }
            });
          } else {
            navigate(response.redirectUrl, {
              replace: true,
              state: {
                translationsMap: { ...translationsMap }
              }
            });
          }
        } else {
          setOpenLoader(false);
          console.log(response.status);
          setMessage(Reader_FailedSendVerifyCode);
        }
      })
      .catch((error) => {
        setOpenLoader(false);
        console.log(error);
        setMessage(Reader_FailedSendVerifyCode);
      });
  };
  const read = (email, recipientId, userCookieId) => {
    var url = `${process.env.REACT_APP_API}/docs/read/${documentId}`;
    var rpdInfo = {
      id: documentId,
      email: email,
      recipientId: recipientId,
      data: "",
      ip: ipAddress,
      userSessionId: userCookieId,
    };

    setOpenLoader(true);
    fetch(url, {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(rpdInfo),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        if (response.authenticated) {
          setOpenLoader(false);
          console.log(documentId);
          console.log(response.recipientId);
          setCookie(
            documentId,
            response.recipientId,
            response.sessionExpireDate
          );
          const redirectPath = new URL(response.redirectUrl).pathname;
          console.log("translationsMap", translationsMap);
          navigate(redirectPath, {
            replace: true,
            state: {
              translationsMap: { ...translationsMap }
            }
          });
        }
      })
      .catch((error) => {
        setOpenLoader(false);
        console.log("Document read error");
      });
  };
  const handleToClose = () => {
    setOpenLoader(false);
    setPasscode("");
    setVerifyEmail("");
    setOpen(false);
    // Clear countdown timer if running
    if (countdownTimerRef.current) {
      clearInterval(countdownTimerRef.current);
      countdownTimerRef.current = null;
    }
  };

  const getPassCodeClick = () => {
    setScreen(2);
    setGetCodeEmail("");
    setMobileNum("");
    setMobileCountryCode("");
    setButtonDisabled(true);
    setSelectedPasscodeOption(0);
  };
  const handleRequestAccess = () => {
    if (getCodeEmail) {
      setOpenReaderNotes(true);
      return;
    }
    requestAccessRef.current.onShow(true, documentId, countryCodes, communicationChannel, showOptionalPlaceholder.current,
      {
        Reader_OK: translationsMap.Reader_OK,
        Reader_LoadingPleaseWait: translationsMap.Reader_LoadingPleaseWait,
        firstNameText: translationsMap.firstNameRef,
        lastNameText: translationsMap.lastNameRef,
        headerText: translationsMap.Reader_RequestAccess,
        navigationPleaseWait: translationsMap.Reader_NavigatingBnPagesPleaseWait,
        loadingPleaseWait: translationsMap.Reader_LoadingPleaseWait,
        readerId: translationsMap.Reader_ID,
        optionalText: translationsMap.optionalText,
        title: (showOptionalPlaceholder.current) ? translationsMap.requestAccessTextForEmail.current : translationsMap.requestAccessTextForEmailMobile.current,
      }
    );
  };
  const handleRequestAccessSucess = () => {
    setOpenRequestSucess(false);
    setReaderNotes("");
  };
  function handlerOpenNotesClosed() {
    setOpenReaderNotes(false);
    setReaderNotes("");
  }


  const onConfirmRequestHandler = (requestDetails) => {
    setOpenReaderNotes(true);
    requestDetailsRef.current = {
      ...requestDetails,
      email: requestDetails.email.trim(),
      mobileNumber: requestDetails.mobileNumber.trim(),
      mobileCountryCode: requestDetails.mobileCountryCode.trim(),
      firstName: requestDetails.firstName.trim(),
      lastName: requestDetails.lastName.trim()
    };
  }

  const handleToContinue = () => {
    var url = `${process.env.REACT_APP_API}/docs/requestaccess`;
    let country_code = "";
    if (requestDetailsRef.current.mobileCountryCode) {
      country_code = requestDetailsRef.current.mobileCountryCode;
    } else {
      country_code = mobileCountryCode && mobileCountryCode.value;
    }

    let rpdInfo = {
      id: documentId,
      email: requestDetailsRef.current.email || getCodeEmail,
      readerNotes: readerNotes.trim(),
      mobileCountryCode: country_code,
      mobileNumber: requestDetailsRef.current.mobileNumber || mobileNum,
      firstName: requestDetailsRef.current.firstName,
      lastName: requestDetailsRef.current.lastName,
    };
    setLoadingmessage(3);
    setOpenLoader(true);
    fetch(url, {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(rpdInfo),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.emailSent == true) {
          setDocSenderAddress(response.senderAddress);
          setOpenRequestSucess(true);
          setOpenLoader(false);
          setOpenReaderNotes(false);
          setPasscode("");
          setVerifyEmail("");
          setOpen(false);
        }
        else if (response.sucess == "false" && response.redirectUrl != null) {
          setOpen(false);
          const redirectPath = new URL(response.redirectUrl).pathname;
          console.log("translationsMap", translationsMap);
          navigate(redirectPath, {
            replace: true,
            state: {
              translationsMap: { ...translationsMap }
            }
          });
        } else if (response.errorMessage) {
          setOpenLoader(false);
          setOpen(true);
          setOpenReaderNotes(false);
          setModelMessage(response.errorMessage);
          setMessageCode("");
          setMobileCountryCode(null);
          setMobileNum("");
          setGetCodeEmail("");
          setButtonDisabled(true);
          setReaderNotes("");
          return;
        }
        setOpen(false);
      })
      .catch((error) => {
        setOpenLoader(false);
        console.log("Document read error");
      });
  };
  const getVerifyScreen = () => {
    setPasscode("");
    if (screen === 3) setVerifyEmail(getCodeEmail);
    else setVerifyEmail("");
    setScreen(1);
  };

  const recaptchaCallback = () => { };

  const togglePassword = () => {
    if (PasscodeType === "password") {
      setPasscodeType("text");
      return;
    }
    setPasscodeType("password");
  };

  let readerHeaderText = "";
  if (communicationChannel.text || communicationChannel.whatsApp) {
    if (selectedPasscodeOption === 1 || !communicationChannel.email) {
      readerHeaderText = translationsMap.passCodeSentViaText
    } else if (selectedPasscodeOption === 2) {
      readerHeaderText = translationsMap.bothEmailAndMobileHeader;
    } else {
      readerHeaderText = translationsMap.Reader_EnterYourEmailAddress;
    }
  } else {
    readerHeaderText = translationsMap.Reader_EnterYourEmailAddress;
  }

  let content = <></>;
  if (communicationChannel.text && communicationChannel.whatsApp) {
    content = (
      <>
        <option value="Text">Text</option>
        <option value="WhatsApp">WhatsApp</option>
      </>
    );
  } else if (communicationChannel.whatsApp) {
    content = <option value="WhatsApp">WhatsApp</option>;
  } else if (communicationChannel.text) {
    content = <option value="Text">Text</option>;
  }

  function onPasscodeOptionSelectionHandler(e) {
    setButtonDisabled(true);
    setGetCodeEmail("");
    setMobileCountryCode(null);
    setMobileNum("");
    setSelectedPasscodeOption(parseInt(e.target.value));
  }

  return (
    <>
      {onlineStatus === false && (
        <div
          className="rpdFont modal"
          id="PagewModel"
          style={{ display: "block", backgroundColor: "#54404061" }}
          onContextMenu={(e) => e.preventDefault()}
        >
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content">
              <div className="modal-body">
                <div className="mb3" style={{ textAlign: "center" }}>
                  <img
                    src={`data:image/png;base64,${noInternetImg}`}
                    className="h-100px"
                  />
                </div>
                <h5
                  className={
                    typeId === "1"
                      ? "text-center noInternetPadding res-font14 RobotoFont"
                      : "text-center noInternetPadding res-font14 rpdFont rd-text"
                  }
                >
                  {translationsMap.Reader_InternetConnectProblem +
                    " " +
                    translationsMap.Reader_ConnectivityReauthenticate}
                </h5>
              </div>
            </div>
          </div>
        </div>
      )}
      {openLoader ? (
        typeId === "1" ? (
          <LoadingXeroxSpinner />
        ) : Loadingmessage == 1 ? (
          <div className="spinerAuth-text">
            <LoadingSpinner authenticatingMsg={translationsMap.Reader_AuthenticatingPleaseWait} />
          </div>
        ) : Loadingmessage == 2 ? (
          <div className="spinerAuth-text">
            <LoadingSpinner authenticatingMsg={translationsMap.Reader_SendingYourPasscode} />
          </div>
        )
          : Loadingmessage == 3 ? (
            <div className="spinerAuth-text">
              <LoadingSpinner authenticatingMsg={translationsMap.Reader_SendingYourRequest} />
            </div>
          ) : (
            <div className="spinerAuth-text">
              <LoadingSpinner authenticatingMsg={translationsMap.Reader_LoadingPleaseWait} />
            </div>
          )
      ) : null}
      {typeId === "1" ? (
        <XeroxHeader
          Reader_ProtectedDocument={translationsMap.Reader_ProtectedDocument}
        ></XeroxHeader>
      ) : (
        <Header
          Reader_ProtectedDocumentAccess={translationsMap.Reader_ProtectedDocumentAccess}
        ></Header>
      )}
      {typeId === "1" ? (
        <main className="RobotoFont xerox-signin">
          {screen === 1 && (
            <div
              id="verify"
              style={{ display: isDisplayVerifyCode ? "block" : "none" }}
            >
              <div className="RobotoFont xerox_card login-padding">
                <div
                  className="RobotoFont d-flex justify-content-center mb-3"
                  style={{ color: "#040921" }}
                >
                  <p className="text-center mt-1 xerox-text font-18px w-100 res-font14">
                    {translationsMap.Reader_EnterYourEmailAddressXerox}:
                    <span className="xerox-wordbreak">
                      {" "}
                      {fileName.split(".").slice(0, -1).join(".")}
                    </span>
                  </p>
                </div>
                <div className="d-flex flex-column justify-content-center">
                  <div className="RobotoFont input-group xerox-group mb-2 pb-2">
                    <div className="input-group-append">
                      <span className="input-group-text xerox-group-text">
                        <img
                          src={email}
                          alt=""
                          className="icon-img"
                          draggable="false"
                        ></img>
                      </span>
                    </div>
                    <input
                      type="text"
                      className="RobotoFont form-control input_user"
                      placeholder={translationsMap.Reader_Email}
                      value={verifyEmail}
                      onChange={(e) => handleVerifyEmail(e)}
                      autoComplete="new-password"
                    ></input>
                  </div>
                  <div className="RobotoFont input-group xerox-group mb-3">
                    <div className="RobotoFont input-group-append">
                      <span className="input-group-text xerox-group-text">
                        <img
                          src={pwd}
                          alt=""
                          className="icicon-img"
                          draggable="false"
                        ></img>
                      </span>
                    </div>
                    <input
                      type={PasscodeType}
                      className="RobotoFont form-control input_pass"
                      placeholder={translationsMap.Reader_Passcode}
                      value={passcode}
                      onChange={(e) => handlePasscode(e)}
                      autoComplete="new-password"
                    ></input>
                    <div className="input-group-btn">
                      <a onClick={togglePassword} style={{ cursor: "pointer" }}>
                        {PasscodeType === "password" ? (
                          <span
                            className="material-icons passwordShow"
                            style={{ color: "#0a4148" }}
                          >
                            visibility_off
                          </span>
                        ) : (
                          <span
                            className="material-icons passwordShow"
                            style={{ color: "#0a4148" }}
                          >
                            remove_red_eye
                          </span>
                        )}
                      </a>
                    </div>
                  </div>
                </div>
                <div className="RobotoFont d-flex justify-content-center mt-3 ">
                  <button
                    type="button"
                    name="button"
                    className="RobotoFont btn login_btn w-100"
                    style={{ lineHeight: "1.6" }}
                    onClick={(e) => verifyCode()}
                  >
                    {translationsMap.Reader_OK}
                  </button>
                </div>
                <div className="RobotoFont d-flex justify-content-center links flex-wrap text-wrap mt-3">
                  <p className="getCode xerox-text" onClick={getPassCodeClick}>
                    {translationsMap.Reader_GetPasscode}
                  </p>
                </div>
                {allowedCountryCodeFlag && (
                  <p className="xeroxemail-text">
                    {translationsMap.Reader_YourDocumentadressAcess}
                    <a
                      className="xeroxreade-more"
                      href="https://rpost.com/legal-notices/privacy-notice-rdocs-supplement"
                      target="_blank"
                    >
                      <i>{translationsMap.Reader_ReadMore}</i>{" "}
                    </a>
                  </p>
                )}
              </div>
            </div>
          )}

          {screen === 2 && (
            <div
              className="RobotoFont xerox_card login-padding"
              id="divPassCode"
            >
              <h4 className="RobotoFont text-center mb-3 xerox-text">
                {translationsMap.Reader_GetPasscode}
              </h4>
              <div className="RobotoFont d-flex flex-column justify-content-start mb-3 flex-dir xerox-text">
                <p className="RobotoFont text-center font-18px text-md-nowrap text-sm-wrap mb-0">
                  {translationsMap.Reader_EnterYourEmailAddressCode}{" "}
                  {fileName.split(".").slice(0, -1).join(".")}
                </p>
              </div>
              <div className="RobotoFont input-group xerox-group mb-3 pb-2">
                <div className="RobotoFont input-group-append">
                  <span className="input-group-text xerox-group-text">
                    <img
                      src={email}
                      alt=""
                      className="icon-img"
                      draggable="false"
                    ></img>
                  </span>
                </div>
                <input
                  id="email"
                  type="text"
                  className="RobotoFont form-control input_user"
                  placeholder={translationsMap.Reader_Email}
                  onKeyUp={(e) => handleKeyUp(e)}
                  value={getCodeEmail}
                  onChange={(e) => handleGetCodeEmail(e)}
                ></input>
              </div>

              <div className="d-flex justify-content-center pt-1 mb-3 ">
                <button
                  type="button"
                  className="RobotoFont w-50 btn btn-outline-secondary me-3 px-4 px-md-5 cpy-1"
                  style={{ border: "1px solid #040921" }}
                  onClick={getVerifyScreen}
                >
                  {translationsMap.Reader_Cancel}
                </button>
                <button
                  type="button"
                  className="RobotoFont w-50 btn btn-secondary cpx-5 cpy-1 xerox-bg"
                  style={{
                    backgroundColor: "#040921 !important",
                    color: "white !important",
                    border: "1px solid #040921",
                  }}
                  onClick={handleClick}
                  disabled={isButtonDisabled}                >
                  {translationsMap.Reader_OK}
                </button>
              </div>
            </div>
          )}

          {screen === 3 && (
            <div
              className="RobotoFont user_card login-padding"
              id="emailsuccess"
            >
              <div className="d-flex justify-content-center">
                <img src={img1} alt="" className="check mb-3"></img>
              </div>

              <h4 className="RobotoFont text-center mb-3 xerox-text">
                {translationsMap.Reader_CheckYourEmail}
              </h4>
              <div
                className="d-flex justify-content-center mb-3 "
                style={{ color: "#000" }}
              >
                <p className="text-center font-1rem text-nowrap1">
                  {message} <br></br>{" "}
                  <div className="text-wrap-custom"> {getCodeEmail}</div>
                </p>
              </div>
              <div className="d-flex justify-content-center login_container">
                <button
                  type="button"
                  className="RobotoFont btn login_btn w-100"
                  style={{ lineHeight: "1.6" }}
                  onClick={getVerifyScreen}
                >
                  {translationsMap.Reader_OK}
                </button>
              </div>
            </div>
          )}
          {screen === 4 && isBlock === true && (
            <div className="RobotoFont user_card login-padding">
              <div className="d-flex justify-content-center">
                <img
                  src={`data:image/png;base64,${blockImg}`}
                  alt=""
                  className="check mb-3"
                ></img>
              </div>
              <div
                className="d-flex justify-content-center mb-3 "
                style={{ color: "#000" }}
              >
                <p className="text-center font-1rem text-nowrap1">
                  {translationsMap.Reader_BlockMessage}
                </p>
              </div>
            </div>
          )}
        </main>
      ) : (
        <main className="rpdFont form-signin ">
          {screen === 1 && (
            <div
              className="rpdFont user_card r-login-padding"
              id="verify"
              style={{ display: isDisplayVerifyCode ? "block" : "none" }}
            >
              <div
                className="rpdFont d-flex flex-column justify-content-center"
                style={{ color: "#040921" }}
              >
                <p className="text-center mb-0 mt-1 font-18px res-font14 fontBold">
                  {readerHeaderText}
                </p>
                <p className="text-center font-18px wordbreak res-font14">
                  {translationsMap.Reader_DocName} {fileName}
                </p>
              </div>
              <div className="rpdFont d-flex justify-content-center links flex-wrap text-wrap ">
                <p
                  className="getCode1"
                  title="Click here to get a passcode to access the document."
                  onClick={getPassCodeClick}
                  style={{
                    backgroundColor: "#ffff00",
                    padding: "2px 6px 2px 6px",
                  }}
                >
                  {translationsMap.Reader_ClickGetPasscode}
                </p>
              </div>
              <div className="rpdFont input-group mb-3 pb-2">
                <div className="input-group-append">
                  <span className="input-group-text rp-text">
                    <i
                      className="material-icons"
                      style={{ fontSize: "22px", color: "#ffff" }}
                    >
                      mail
                    </i>
                  </span>
                </div>
                <input
                  type="text"
                  className="rpdFont form-control input_user"
                  placeholder={translationsMap.Reader_RPostEmail}
                  value={verifyEmail}
                  onChange={(e) => handleVerifyEmail(e)}
                  autoComplete="new-password"
                ></input>
              </div>
              <div className="rpdFont input-group mb-3">
                <div className="input-group-append">
                  <span className="input-group-text rp-text">
                    <i
                      className="material-icons"
                      style={{ fontSize: "22px", color: "#ffff" }}
                    >
                      key
                    </i>
                  </span>
                </div>
                <input
                  type={PasscodeType}
                  className="rpdFont form-control input_pass"
                  placeholder={translationsMap.RPostEmail_Passcode}
                  value={passcode}
                  onChange={(e) => handlePasscode(e)}
                  onKeyDown={(e) => {
                    if (e.key === " ") e.preventDefault(); // Block space
                  }}
                  autoComplete="new-password"
                ></input>
                <div className="input-group-btn">
                  <a onClick={togglePassword} style={{ cursor: "pointer" }}>
                    {PasscodeType === "password" ? (
                      <span className="material-icons passwordShow">
                        visibility_off
                      </span>
                    ) : (
                      <span className="material-icons passwordShow">
                        remove_red_eye
                      </span>
                    )}
                  </a>
                </div>
              </div>
              <div className="rpdFont d-flex justify-content-center mt-3 pt-1 login_container">
                <button
                  type="button"
                  name="button"
                  className="rpdFont btn login_btn w-md-75 rp-btn"
                  style={{ lineHeight: "1.6", fontSize: "17px" }}
                  onClick={(e) => verifyCode()}
                >
                  {translationsMap.Reader_Authorize}
                </button>
              </div>
              <div className="rpdFont">
                {allowedCountryCodeFlag && (
                  <p className="email-text">
                    {translationsMap.Reader_YourDocumentadressAcess}
                    <a
                      className="reade-more"
                      href="https://rpost.com/legal-notices/privacy-notice-rdocs-supplement"
                      target="_blank"
                    >
                      <i>{translationsMap.Reader_ReadMore}</i>{" "}
                    </a>
                  </p>
                )}
                <p className="rpdFont mb-0 doc-id">
                  {translationsMap.Reader_ID} {documentId}
                </p>
              </div>
            </div>
          )}

          {screen === 2 && (
            <div className="rpdFont user_card r-login-padding" id="divPassCode">
              <h4
                className="modal-title text-center mb-3 rd-text"
                style={{ fontWeight: "500" }}>
                {translationsMap.RPosteader_GetPasscode}
              </h4>
              <div className="rpdFont d-flex  flex-column justify-content-start mb-3 rd-text flex-dir">
                <p className="text-center font-18px text-md-nowrap text-sm-wrap mb-0 fontBold">
                  {((communicationChannel.text || communicationChannel.whatsApp) && (communicationChannel.email))
                    ? translationsMap.Reader_EnterYourEmailAddressCodeTextOption
                    : (communicationChannel.text || communicationChannel.whatsApp)
                      ? translationsMap.Reader_MobileNumberPasscodeText
                      : (communicationChannel.email)
                        ? translationsMap.Reader_RPostEnterYourEmailAddressCode : ""}
                </p>
                <p className="text-center font-18px wordbreak">{fileName}</p>
              </div>
              {((communicationChannel.text || communicationChannel.whatsApp) && (communicationChannel.email)) && (
                <div className="passCodeOptions">
                  {passcodeOptions.current.length > 0 &&
                    passcodeOptions.current.map((passcodeOption, index) => {
                      return (
                        <>
                          <span className="radio me-4" key={passcodeOption}>
                            <input
                              type="radio"
                              value={index}
                              onChange={onPasscodeOptionSelectionHandler}
                              checked={
                                selectedPasscodeOption === index
                              }
                            />
                            <label>{passcodeOption}</label>
                          </span>
                        </>
                      );
                    })}
                </div>
              )}
              {(communicationChannel.text && !communicationChannel.email) && (
                <>
                  <div className="input-group mb-3 pb-2">
                    <div className="input-group-append">
                      <span className="input-group-text rp-text">
                        <i
                          className="material-icons"
                          style={{ fontSize: "22px", color: "#ffff" }}>
                          phone_iphone
                        </i>
                      </span>
                    </div>
                    <Select
                      value={mobileCountryCode?.value ? mobileCountryCode : globePlaceholder}
                      onChange={handleMobileCountryCode}
                      options={countryCodes}
                      styles={{
                        placeholder: (base) => ({
                          ...base,
                        }),
                        control: (provided) => ({
                          ...provided,
                          height: "40px",
                          width: "130px",
                          border: "1px solid #ccc",
                          borderRadius: "0px 0 0 0px",
                          boxShadow: "none",
                          cursor: "pointer",
                          wordBreak: "normal",
                          whiteSpace: "nowrap",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                          width: "253px",
                          maxHeight: "353px", // Limit height for scrolling
                          overflowY: "auto", // Enable vertical scrolling
                        }),
                        menuPortal: (provided) => ({
                          ...provided,
                        }),
                        indicatorSeparator: () => ({
                          display: "none",
                        }),
                      }}
                      menuPosition="absolute"
                      getOptionLabel={(e) => `${e.label}`}
                      getOptionValue={(e) => `${e.value}`}
                      formatOptionLabel={(data, { context }) => (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            className={`${data.label === "+Code"
                              ? "bg-  "
                              : `bg-${data.languageCode}`
                              }`}
                            style={{
                              width: "36px",
                            }}></div>
                          {context === "menu"
                            ? `${data.label}`
                            : `${data.value.split("-")[0]}`}
                        </div>
                      )}
                      noOptionsMessage={() => null}
                    />
                    <input
                      id="mobile"
                      type="text"
                      className="rpdFont form-control input_user"
                      placeholder={"Mobile"}
                      value={mobileNum}
                      onChange={handleMobileNum}
                      onKeyUp={(e) => handleKeyUp(e)}></input>
                    {communicationChannel.text &&
                      communicationChannel.whatsApp && (
                        <select id="options" ref={selectCommunication}>
                          <option value="">{"Select"}</option>
                          {content}
                        </select>
                      )}
                  </div>
                </>
              )}

              {((!communicationChannel.text &&
                !communicationChannel.whatsApp) && communicationChannel.email) && (
                  <>
                    <div className="input-group mb-3 pb-2">
                      <div className="input-group-append">
                        <span className="input-group-text rp-text">
                          <i
                            className="material-icons"
                            style={{ fontSize: "22px", color: "#ffff" }}>
                            mail
                          </i>
                        </span>
                      </div>

                      <input
                        id="email"
                        type="text"
                        className="rpdFont form-control input_user"
                        onKeyUp={(e) => handleKeyUp(e)}
                        placeholder={translationsMap.Reader_RPostEmail}
                        value={getCodeEmail}
                        onChange={(e) => handleGetCodeEmail(e)}></input>
                    </div>
                  </>
                )}
              {((communicationChannel.text || communicationChannel.whatsApp) && (communicationChannel.email)) &&
                (selectedPasscodeOption === 0 ||
                  selectedPasscodeOption === 2) && (
                  <>
                    <div className="input-group mb-3 pb-2">
                      <div className="input-group-append">
                        <span className="input-group-text rp-text">
                          <i
                            className="material-icons"
                            style={{ fontSize: "22px", color: "#ffff" }}>
                            mail
                          </i>
                        </span>
                      </div>

                      <input
                        id="email"
                        type="text"
                        className="rpdFont form-control input_user"
                        onKeyUp={(e) => handleKeyUp(e)}
                        placeholder={translationsMap.Reader_RPostEmail}
                        value={getCodeEmail}
                        onChange={(e) => handleGetCodeEmail(e)}></input>
                    </div>
                  </>
                )}

              {((communicationChannel.text || communicationChannel.whatsApp) && (communicationChannel.email)) &&
                (selectedPasscodeOption === 1 ||
                  selectedPasscodeOption === 2) && (
                  <div className="input-group mb-3 pb-2">
                    <div className="input-group-append">
                      <span className="input-group-text rp-text">
                        <i
                          className="material-icons"
                          style={{ fontSize: "22px", color: "#ffff" }}>
                          phone_iphone
                        </i>
                      </span>
                    </div>
                    <Select
                      value={mobileCountryCode?.value ? mobileCountryCode : globePlaceholder}
                      onChange={handleMobileCountryCode}
                      options={countryCodes}
                      styles={{
                        placeholder: (base) => ({
                          ...base,
                        }),
                        control: (provided) => ({
                          ...provided,
                          height: "40px",
                          width: "130px",
                          border: "1px solid #ccc",
                          borderRadius: "0px 0 0 0px",
                          boxShadow: "none",
                          cursor: "pointer",
                          wordBreak: "normal",
                          whiteSpace: "nowrap",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                          width: "253px",
                          maxHeight: "353px", // Limit height for scrolling
                          overflowY: "auto", // Enable vertical scrolling
                        }),
                        menuPortal: (provided) => ({
                          ...provided,
                        }),
                        indicatorSeparator: () => ({
                          display: "none",
                        }),
                      }}
                      menuPosition="absolute"
                      getOptionLabel={(e) => `${e.label}`}
                      getOptionValue={(e) => `${e.value}`}
                      formatOptionLabel={(data, { context }) => (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            className={`${data.label === "+Code"
                              ? "bg-  "
                              : `bg-${data.languageCode}`
                              }`}
                            style={{
                              width: "36px",
                            }}></div>
                          {context === "menu"
                            ? `${data.label}`
                            : `${data.value.split("-")[0]}`}
                        </div>
                      )}
                      noOptionsMessage={() => null}
                    />
                    <input
                      id="mobile"
                      type="text"
                      className="rpdFont form-control input_user"
                      placeholder={"Mobile"}
                      value={mobileNum}
                      onChange={handleMobileNum}
                      onKeyUp={(e) => handleKeyUp(e)}></input>
                    {communicationChannel.text &&
                      communicationChannel.whatsApp && (
                        <select id="options" ref={selectCommunication}>
                          <option value="">{"Select"}</option>
                          {content}
                        </select>
                      )}
                  </div>
                )}
              <div className="rpdFont d-flex justify-content-center pt-1 mb-3 login_container">
                <button
                  type="button"
                  className="rpdFont w-50 btn btn-outline-secondary me-3 px-4 px-md-5 cpy-1"
                  style={{ border: "1px solid #040921" }}
                  onClick={getVerifyScreen}>
                  {translationsMap.Reader_Cancel}
                </button>
                <button
                  type="button"
                  className="rpdFont w-50 btn btn-secondary cpx-5 cpy-1 rp-btn"
                  style={{
                    backgroundColor: "#040921 !important",
                    color: "white !important",
                    border: "1px solid #040921",
                  }}
                  disabled={isButtonDisabled}
                  onClick={handleClick}
                >
                  {translationsMap.Reader_OK}
                </button>
              </div>
              <div
                className="rpdFont mt-2"
                style={{
                  fontStyle: "italic",
                  fontFamily: "Calibri",
                  fontSize: "9pt",
                  color: "#7F7F7F",
                  textAlign: "center",
                  marginBottom: "-25px",
                }}
              >
                {translationsMap.Reader_ID} {documentId}
              </div>
            </div>
          )}

          {screen === 3 && (
            <div
              className="rpdFont user_card r-login-padding"
              id="emailsuccess"
            >
              <div className="d-flex justify-content-center">
                <img src={check} alt="" className="check mb-3"></img>
              </div>

              <h4 className="rpdFont modal-title text-center mb-3 rd-text">
                {(authTypeSelectedForRecipient.current == "text" || selectedPasscodeOption == 1) ? translationsMap.checkYourMobile :
                  (authTypeSelectedForRecipient.current == "email" || selectedPasscodeOption == 0) ? translationsMap.RPostReader_CheckYourEmail :
                    (authTypeSelectedForRecipient.current == "both" || selectedPasscodeOption == 2) ? translationsMap.checkYourEmailMobile : ""}
              </h4>
              <div
                className="d-flex justify-content-center mb-3 rd-text"
                style={{ color: "#000" }}
              > {(communicationChannel.text || communicationChannel.whatsApp) &&
                selectedPasscodeOption === 2 ?
                <p className="rpdFont text-center font-1rem text-nowrap1">
                  {message.replace("{0}", getCodeEmail).replace("{1}", `${(mobileCountryCode.value == undefined || mobileCountryCode.value == "+Code") ? "" : mobileCountryCode.value}` + " " + `${mobileNum}`)} <br></br>{" "}
                </p>
                : selectedPasscodeOption === 1 ?
                  <p className="rpdFont text-center font-1rem text-nowrap1">
                    {`${message} ${(mobileCountryCode.value == undefined || mobileCountryCode.value == "+Code") ? "" : mobileCountryCode.value}` + " " + `${mobileNum}`} <br></br>{" "}
                  </p>
                  :
                  <p className="rpdFont text-center font-1rem text-nowrap1">
                    {message} <br></br>{" "}
                    <div className="text-wrap-custom"> {getCodeEmail}</div>
                  </p>
                }
              </div>
              <div className="rpdFont d-flex justify-content-center login_container">
                <button
                  type="button"
                  className="rpdFont btn login_btn w-sm-100 w-md-50 rp-btn"
                  style={{ lineHeight: "1.6" }}
                  onClick={getVerifyScreen}
                >
                  {translationsMap.Reader_OK}
                </button>
              </div>
            </div>
          )}
          {isBlock === true && screen === 4 && (
            <div className="user_card">
              <div className="rpdFont d-flex justify-content-center">
                <img
                  src={`data:image/png;base64,${blockImg}`}
                  alt=""
                  className="check mb-3"
                ></img>
              </div>
              <div className="d-flex flex-column justify-content-center mb-3">
                <p className="rpdFont text-center font-1rem text-nowrap1 rd-text">
                  {translationsMap.Reader_BlockMessage}
                </p>
              </div>
            </div>
          )}
        </main>
      )}

      {typeId === "1" ? (
        <div className="text-end document-id">
          <label className="text-end font-8">
            {Reader_ID} {documentId}
          </label>
        </div>
      ) : (
        <div></div>
      )}

      {typeId === "1" ? (
        <XeroxFooter
          Reader_AllRightsReserved={translationsMap.Reader_AllRightsReserved}
          Reader_Terms={translationsMap.Reader_Terms}
        ></XeroxFooter>
      ) : (
        <DefaultFooter
          Reader_GeneralTermsFooter={translationsMap.Reader_GeneralTermsFooter}
          Reader_LegalNotices={translationsMap.Reader_LegalNotices}
          Reader_ClickServiceLevelTerms={translationsMap.Reader_ClickServiceLevelTerms}
          Reader_Patent={translationsMap.Reader_Patent}
          Reader_OtherService={translationsMap.Reader_OtherService}
        ></DefaultFooter>
      )}
      {modelopen === true && (
        <div
          className="modal"
          id="myModal1"
          style={{ display: "block", backgroundColor: "#8080801c" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content">
              <div className="modal-body" style={{ padding: "0.9rem" }}>
                <h5
                  className={
                    typeId === "1"
                      ? "text-center my-4 res-font14 RobotoFont xerox-text"
                      : "text-center my-4 res-font14 rpdFont rd-text"
                  }>
                  <span className="text-warn-text text-wrap-custom">
                    {modelMessage}
                  </span>
                </h5>

                <div className="mb-3 justify-content-center d-flex">
                  <button
                    type="button"
                    className="btn btn-secondary w-50 py-2"
                    data-bs-dismiss="modal"
                    style={{
                      background: typeId === "1" ? "#0a4148" : "#040921",
                    }}
                    onClick={handleToClose}
                  >
                    {translationsMap.Reader_OK}
                  </button>
                  {messageCode == "RPD001" && (
                    <button
                      type="button"
                      className="btn btn-secondary w-50 py-2 ms-3"
                      data-bs-dismiss="modal"
                      style={{
                        background: typeId === "1" ? "#0a4148" : "#040921",
                      }}
                      onClick={handleRequestAccess}
                    >
                      {translationsMap.reader_RequestAccess}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {openReaderNotes === true && (
        <div
          className="modal"
          id="myModal1"
          style={{ display: "block", backgroundColor: "#54404061" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content" style={{ marginTop: "5%" }}>
              <div className="modal-header pb-1">
                <h4
                  className="d-flex align-items-center text-danger fw-bold "
                  htmlFor=""
                >
                  {translationsMap.Reader_Note}
                </h4>
                <button
                  type="button"
                  className="btn modalclose download"
                  style={{ color: "#dc3545" }}
                  onClick={(e) => handlerOpenNotesClosed()}
                >
                  <span className="material-icons font-20">highlight_off</span>
                </button>
              </div>
              <div className="modal-body mb-1 justify-content-center d-flex">
                <textarea
                  name="ReaderNotes"
                  draggable="false"
                  style={{ resize: "none", width: "95%" }}
                  placeholder={translationsMap.Reader_Optional}
                  rows="5"
                  maxlength="255"
                  value={readerNotes}
                  onChange={(e) => setReaderNotes(e.target.value)}
                ></textarea>
              </div>
              <div className="mb-2 justify-content-center d-flex">
                <button
                  type="button"
                  className="btn btn-secondary py-2 p-3"
                  data-bs-dismiss="modal"
                  style={{
                    background: typeId === "1" ? "#0a4148" : "#040921",
                  }}
                  onClick={handleToContinue}
                >
                  {translationsMap.Reader_Continue}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {openRequestSucess === true && (
        <div
          className="modal"
          id="myModal1"
          style={{ display: "block", backgroundColor: "#54404061" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content">
              <div className="justify-content-center d-flex">
                <div
                  className="rpdFont user_card r-login-padding"
                  id="emailsuccess"
                >
                  <div className="d-flex justify-content-center">
                    <img src={check} alt="" className="check mb-3"></img>
                  </div>
                  <div
                    className="d-flex justify-content-center mb-3 rd-text"
                    style={{ color: "#000" }}
                  >
                    <p className="rpdFont text-center font-1rem text-nowrap1">
                      {translationsMap.Email_RequestHasBeenSent}:
                      <span className="text-warn-text text-wrap-custom">
                        {" "}
                        {docSenderAddress}
                      </span>{" "}
                      <br></br>{" "}
                      <div className="text-wrap-custom">
                        {" "}
                        {translationsMap.Email_PleaseWaitForApproval}
                      </div>
                    </p>
                  </div>
                  <div className="rpdFont d-flex justify-content-center login_container">
                    <button
                      type="button"
                      className="rpdFont btn login_btn w-sm-100 w-md-50 rp-btn"
                      style={{ lineHeight: "1.6" }}
                      onClick={handleRequestAccessSucess}
                    >
                      {translationsMap.Reader_OK}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <PersonalInfo ref={personalInfoRef} />
      <EDisclosure ref={disclaimerRef} />
      <RequestAccess onConfirmRequestAccess={onConfirmRequestHandler} ref={requestAccessRef} />
    </>
  );
};

export default Code;
